import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar-month-week-row flex between-xs" }

import { isBetweenDates } from '../util/dateUtils';
import isSameDay from 'date-fns/is_same_day';
import isBefore from 'date-fns/is_before';
import DayButton from './DayButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WeekRow',
  props: {
  dates: {
    type: Array<Date>,
    default: [],
  },
  week: {
    type: Array<Date>,
    required: true,
  },
  minDate: {
    type: Date,
    required: true,
  },
  maxDate: {
    type: Date,
    required: true,
  },
},
  setup(__props) {

const props = __props



function isSelected(day) {
  return (
    props.dates &&
    props.dates.length > 1 &&
    props.dates[1] &&
    day > props.dates[0] &&
    day < props.dates[1] &&
    !isSameDay(day, props.dates[0]) &&
    !isSameDay(day, props.dates[1])
  );
}

function getDisableDates(day) {
  if (day === null) return false;
  return isSameDay(day, props.minDate)
    ? false
    : props.maxDate
    ? !isBetweenDates(day, props.minDate, props.maxDate)
    : isBefore(day, props.minDate);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.week, (day, index) => {
      return (_openBlock(), _createBlock(DayButton, {
        key: index,
        class: _normalizeClass([{ 'in-range': isSelected(day) }]),
        disabled: getDisableDates(day),
        dates: __props.dates,
        day: day
      }, null, 8, ["class", "disabled", "dates", "day"]))
    }), 128))
  ]))
}
}

})